import { useEffect, useState } from 'react';

import { getZipUtilityFile } from '@/clients/ecomm/zipUtilityClient';
import type { ZipDataType } from '@/utils/zipUtility';

const useZipData = () => {
  const [zipData, setZipData] = useState<null | ZipDataType>();

  // biome-ignore lint/correctness/useExhaustiveDependencies: Automated migration to Biome
  useEffect(() => {
    const fetchZipFile = async () => {
      try {
        const data = await getZipUtilityFile();
        setZipData(data);
      } catch {
        console.error('Error - could not fetch zip utility file');
        setZipData(null);
      }
    };
    if (!zipData) {
      fetchZipFile();
    }
  }, []);

  return {
    zipData,
  };
};

export default useZipData;
